import {FormControl } from '@angular/forms';


export function FileFormatValidator(allowedExtensions: string[], customMessage="Formato de archivo no permitido") {
  return (control: FormControl): { [key: string]: any } | null => {
    if (control.value) {
      const fileExtension = control.value.split('.').pop().toLowerCase();
      if (allowedExtensions.indexOf(fileExtension) === -1) {
        return { invalidFileFormat: customMessage};
      }
    }
    return null;
  };
}
